{
  "home": {
    "heroStop": "STOP HUMAN SAFARI",
    "heroSave": "RATUJMY CHERSOŃ",
    "heroTitle1": "Ludzie",
    "heroTitle2": "to nie cele",
    "heroDate": "13, 14 grudnia",
    "worldwideRally": "Ogólno&shy;światowy wiec",
    "heroHashtags": "#HumansAreNotTargets #StopHumanSafari #SaveKherson",
    "infoText": "Od lata 2024 roku rosyjskie wojsko używa małych dronów, by polować na cywilów, zabijać ich i terroryzować na ulicach Chersonia i innych przyfrontowych miast Ukrainy. <bold>Human Safari musi się skończyć. TY możesz pomóc.</bold> Dołącz do tysięcy ludzi na całym świecie, którzy domagają się powstrzymania tej zbrodni wojennej.",
    "seeGallery": "Zobacz plakaty z całego świata",
    "comingSoon": "Lokalizacje wkrótce",
    "december": "grudnia",
    "dec": "gru",
    "october": "października",
    "oct": "paź",
    "september": "września",
    "sep": "wrz",
    "schedule9": "9",
    "schedule10": "10",
    "schedule11": "11",
    "schedule12": "12",
    "schedule13": "13",
    "schedule14": "14",
    "schedule16": "16",
    "schedule18": "18",
    "schedule20": "20",
    "schedule1": "1",
    "schedule2": "2",
    "schedule3": "3",
    "schedule4": "4",
    "schedule5": "5",
    "schedule25": "25",
    "schedule26": "26",
    "schedule27": "27",
    "schedule28": "28",
    "schedule29": "29",
    "schedule30": "30",
    "schedule31": "31",
    "scheduleTBC": "Potwierdzamy datę...",
    "recommendationsTitle": "Zalecenia Komisji ONZ",
    "recommendationsRussia": "Komisja zaleca, aby Federacja Rosyjska:",
    "rusRec1": "(a) Natychmiast zaprzestała ataków dronów wymierzonych w ludność cywilną i obiekty cywilne",
    "rusRec2": "(b) Natychmiast zaprzestała wszelkich działań szerzących terror wśród ludności cywilnej",
    "rusRec3": "(c) Zapewniła pociągnięcie do odpowiedzialności wszystkich sprawców ataków dronów na ludność cywilną",
    "recommendationsUNStates": "Komisja zaleca, aby inne państwa oraz organizacje regionalne i międzynarodowe: ",
    "statesRec1": "(a) Wspierały finansowo i doradztwem technicznym rząd Ukrainy oraz organizacje społeczeństwa obywatelskiego w zapewnianiu kompleksowej pomocy ofiarom i ich rodzinom;",
    "statesRec2": "(b) W przypadku państw trzecich, do których deportowano osoby z terytoriów okupowanych – podjęły, wspólnie z ukraińskimi służbami konsularnymi, niezbędne działania w celu wsparcia tych osób.",
    "reference": "Źródła",
    "linkUN": "Komisja ONZ: rosyjskie „human safari” na Ukrainie to zbrodnia przeciwko ludzkości",
    "linkGuidelines": "Wytyczne ONZ",
    "linkWiki": "Wikipedia"
  },
  "witnesses": {
    "title": " Zbieramy relacje naocznych świadków!",
    "email": "Jeśli pochodzisz z Chersonia, Nikopola, Zaporoża, Sum lub przyfrontowych terenów Donbasu i na własne oczy widziałeś/-aś „human safari”, prześlij nam swoją historię na 📧 <mail>khersonhumansafari@gmail.com</mail>, w temacie: „human safari”.",
    "type": " Jeśli byłeś/-aś świadkiem śmierci przyjaciela lub sąsiada w ataku drona i chcesz podzielić się swoją relacją, napisz „świadek”; jeśli sam/-a zostałeś/-aś zaatakowany/-a, napisz „ocalały/-a”.",
    "requirements": "<b>Czego potrzebujemy:</b> miasto/miejsce, data ataku, krótka historia (3–6 zdań; rzeczowo, w pierwszej osobie).",
    "honesty": "Pisz szczerze i zwięźle, nie podawaj wrażliwych informacji o pozycjach wojskowych — możesz pozostać anonimowy/-a.",
    "media": "<b>Zdjęcia/filmy?</b> Napisz „Mam zdjęcia/filmy”. Nie załączaj plików — skontaktujemy się, jeśli będą potrzebne.",
    "consent": "<b>Zgoda na publikację:</b> „Zgadzam się na publiczne opublikowanie tej historii na stronie HumanSafari.org”."
  },
  "resources": {
    "title": "Najważniejsze źródła",
    "linkLibraryTitle": "Biblioteka linków",
    "linkLibraryDesc": "200 artykułów, raportów, wywiadów, relacji z pierwszej ręki i materiałów medialnych",
    "humanSafariMapTitle": "Mapa Human Safari – Tochnyi",
    "humanSafariMapDesc": "Interaktywna mapa ataków Human Safari w Chersoniu, opracowana na podstawie otwartych raportów władz lokalnych oraz nagrań ataków zgeolokalizowanych przez zespół Tochnyi.",
    "truthHoundsTitle": "Raport Truth Hounds",
    "truthHoundsDesc": "Strefa śmierci: jak rosyjskie drony pustoszą prawy brzeg Dniepru",
    "hrwTitle": "Raport Human Rights Watch o atakach dronów w Chersoniu",
    "hrwDesc": "Raport HRW",
    "unReportsTitle": "Raporty Rady Praw Człowieka ONZ",
    "report1": "Raport ONZ nr 1",
    "report3": "Raport ONZ nr 3",
    "guidelines": "Wytyczne ONZ",
    "wikipediaTitle": "Wikipedia",
    "english": "angielski",
    "french": "francuski",
    "documentaryTitle": "Film dokumentalny",
    "documentaryDesc": "www.khersonhumansafari.com"
  },
  "navbar": {
    "main": "13-14 grudnia",
    "eyewitnesses": "relacje",
    "rallies": "zdjęcia",
    "help": "wyzwolony Chersoń",
    "leftBank": "okupowany Chersoń",
    "action": "gru '25",
    "oleshky": "globalna demonstracja - Oleszki",
    "menu": "Menu"
  },
  "leftBank": {
    "pageTitle": "Oblężenie dronami",
    "para1": "Ostry kryzys humanitarny dotyka 6000 cywilów uwięzionych w oblężeniu dronami w okupowanych Oleszkach, Hołej Prystani, Starej Zburiwce i Nowej Zburiwce w okupowanym obwodzie chersońskim. W samych Oleszkach to 1200–2000 osób. Władza okupacyjna ma obowiązek im pomagać — zamiast tego rosyjskie siły wykorzystują ich jako żywe tarcze, kryjąc się za tą ludnością podczas ataków Human Safari na przeciwległy brzeg. Władze ukraińskie i organizacje humanitarne informują o systematycznym utrudnianiu ewakuacji i dostępu humanitarnego.",
    "para2": "Cywilom brakuje żywności, wody, opieki medycznej, leków, prądu, gazu i łączności. Drogi są gęsto zaminowane, a drony ograniczają możliwość poruszania się. Od 26 maja żaden pojazd nie zdołał wjechać ani wyjechać. Zapasy paliwa i żywności są niemal wyczerpane.",
    "meidasTitle": "Meidas Touch / Valor Media Network",
    "meidasVideo": "Film: Chersoń i Oleszki. Świadkowie ludobójstwa (12 min)",
    "meidasArticle": "Artykuł: Obwód chersoński. Jak Rosja wykorzystuje cywilów jako narzędzie wojny (5 min czytania)",
    "kyivPostTitle": "Kyiv Post",
    "kyivPostArticle": "Artykuł: Społeczność międzynarodowa wzywa do pilnej ewakuacji z Oleszek w obliczu pogarszających się warunków (7 min czytania)",
    "tellPost": "i opowiadaj innym o oblężeniu dronami",
    "callToHelp": "TY możesz pomóc. Oto jak",
    "donateIntro": "To inicjatywy, które zapewniają skuteczną, ukierunkowaną pomoc bezpośrednio osobom, które uciekły z Oleszek lub, tam gdzie to możliwe, są w nich uwięzione.",
    "signTitle": "Podpisz",
    "signSub": "petycje",
    "petitionBy": "od {{name}}",
    "petitions": {
      "euParliament": "Parlament Europejski – Petycja nr 1439/2026 w sprawie utworzenia humanitarnego korytarza ewakuacyjnego dla cywilów uwięzionych w oblężeniu w okupowanych przez Rosję Oleszkach na Ukrainie",
      "ukParliament": "Parlament Wielkiej Brytanii – Utworzenie prowadzonego przez Wielką Brytanię korytarza pomocy humanitarnej do Oleszek na Ukrainie"
    },
    "publicActionLead": "Zwróć uwagę na oblężenie dronami tam, gdzie jesteś.",
    "organiseAction": "Zorganizuj akcję.",
    "policyBody": "Władze ukraińskie prowadzą konsultacje z Międzynarodowym Komitetem Czerwonego Krzyża w sprawie utworzenia humanitarnego korytarza ewakuacyjnego z okupowanych miejscowości obwodu chersońskiego oraz zapewnienia dostępu humanitarnego dla żywności, wody, leków, paliwa i pomocy medycznej. Na początku czerwca nie działał żaden korytarz ewakuacyjny ani stały mechanizm dostępu humanitarnego.",
    "documentaryTitle": "Oleszki – krótki film dokumentalny",
    "downloadTitle": "Pobierz",
    "downloadSub": "grafiki"
  },
  "footer": {
    "addCityText": "Aby dodać swoje miasto, napisz na adres: ",
    "organiseText": "Dodaj swoją demonstrację – skontaktuj się z nami:",
    "contact": "Kontakt:"
  },
  "byCountry": "według kraju",
  "byDate": "według daty",
  "countries": {
    "australia": "Australia",
    "austria": "Austria",
    "bulgaria": "Bułgaria",
    "canada": "Kanada",
    "czechia": "Czechy",
    "denmark": "Dania",
    "estonia": "Estonia",
    "finland": "Finlandia",
    "france": "Francja",
    "georgia": "Gruzja",
    "germany": "Niemcy",
    "hungary": "Węgry",
    "italy": "Włochy",
    "japan": "Japonia",
    "mexico": "Meksyk",
    "netherlands": "Holandia",
    "norway": "Norwegia",
    "poland": "Polska",
    "romania": "Rumunia",
    "spain": "Hiszpania",
    "sweden": "Szwecja",
    "southAfrica": "Republika Południowej Afryki",
    "ukraine": "Ukraina",
    "unitedKingdom": "Wielka Brytania",
    "usa": "USA",
    "ireland": "Irlandia",
    "belgium": "Belgia"
  },
  "cities": {
    "alicante": {
      "city": "Alicante",
      "country": "Hiszpania",
      "time": "Alicante - Hiszpania, 16:00 - 17:00",
      "location": "Auditorio la Concha, Explanada de España",
      "cleanTime": "16:00 - 17:00",
      "day": "schedule13"
    },
    "barcelona": {
      "city": "Barcelona",
      "country": "Hiszpania",
      "time": "Barcelona - Hiszpania, 12:00 - 14:00",
      "location": "Placa de Sant Jaume",
      "cleanTime": "12:00 - 14:00",
      "day": "schedule14"
    },
    "berkeley": {
      "city": "Berkeley",
      "country": "USA",
      "time": "Berkeley - USA, 12:00 - 13:00",
      "location": "4th St.",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "berlin": {
      "city": "Berlin",
      "country": "Niemcy",
      "time": "Berlin - Niemcy, 12:00",
      "location": "Tempelhofer Feld, wejście Leinstr./róg Oderstr.",
      "cleanTime": "12:00",
      "day": "schedule14"
    },
    "bettendorf": {
      "city": "Bettendorf",
      "country": "USA",
      "time": "Bettendorf - USA, 17:30 - pokaz filmu",
      "location": "Biblioteka publiczna w Bettendorf",
      "cleanTime": "17:30 - pokaz filmu",
      "day": "schedule11"
    },
    "birmingham": {
      "city": "Birmingham",
      "country": "Wielka Brytania",
      "time": "Birmingham - Wielka Brytania, 14:00 - 15:30",
      "location": "Baskerville House, Cambridge St.",
      "cleanTime": "14:00 - 15:30",
      "day": "schedule13"
    },
    "bonn": {
      "city": "Bonn",
      "country": "Niemcy",
      "time": "Bonn - Niemcy, 14:00 - 16:00",
      "location": "Poststraße, przed dworcem głównym (Hauptbahnhof)",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule14"
    },
    "bremen": {
      "city": "Brema",
      "country": "Niemcy",
      "time": "Brema - Niemcy, 15:00 - 18:00",
      "location": "Bahnhofsvorplatz",
      "cleanTime": "15:00 - 18:00",
      "day": "schedule14"
    },
    "budapest": {
      "city": "Budapeszt",
      "country": "Węgry",
      "time": "Budapeszt - Węgry, do potwierdzenia",
      "location": "",
      "cleanTime": "do potwierdzenia",
      "day": "scheduleTBC"
    },
    "chicago": {
      "city": "Chicago",
      "country": "USA",
      "time": "Chicago - USA, 13:00 - 15:00",
      "location": "410 N. Michigan ave. (budynek Wrigley)",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule14"
    },
    "constanta": {
      "city": "Konstanca",
      "country": "Rumunia",
      "time": "Konstanca - Rumunia, do potwierdzenia",
      "location": "",
      "cleanTime": "do potwierdzenia",
      "day": "scheduleTBC"
    },
    "copenhagen": {
      "city": "Kopenhaga",
      "country": "Dania",
      "time": "Kopenhaga - Dania, 14:00",
      "location": "Axeltorv",
      "cleanTime": "14:00",
      "day": "schedule14"
    },
    "dallas": {
      "city": "Dallas",
      "country": "USA",
      "time": "Dallas - USA, 12:00 - 13:00",
      "location": "Dallas City Hall Plaza",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "denver": {
      "city": "Denver",
      "country": "USA",
      "time": "Denver - USA, 12:00",
      "location": "Kapitol stanu Kolorado, zachodnie schody",
      "cleanTime": "12:00",
      "day": "schedule14"
    },
    "edinburgh": {
      "city": "Edynburg",
      "country": "Wielka Brytania",
      "time": "Edynburg - Wielka Brytania, 13:00 - 15:00",
      "location": "Pomnik księcia Wellingtona",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule13"
    },
    "fortWorth": {
      "city": "Fort Worth",
      "country": "USA",
      "time": "Fort Worth - USA, 14:00 - 15:00",
      "location": "Sąd hrabstwa Tarrant",
      "cleanTime": "14:00 - 15:00",
      "day": "schedule14"
    },
    "hamburg": {
      "city": "Hamburg",
      "country": "Niemcy",
      "time": "Hamburg - Niemcy, 14:00 - 16:00",
      "location": "Mönckebergbrunnen (Mönckebergstraße)",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule20"
    },
    "houghton": {
      "city": "Houghton, Michigan",
      "country": "USA",
      "time": "Houghton, Michigan - USA, 15:00",
      "location": "Portage Lake Lift Bridge",
      "cleanTime": "15:00",
      "day": "schedule14"
    },
    "helsinki": {
      "city": "Helsinki",
      "country": "Finlandia",
      "time": "Helsinki - Finlandia, 17:00 - 18:00",
      "location": "Narinkkatori",
      "cleanTime": "17:00 - 18:00",
      "day": "schedule16"
    },
    "izumo14": {
      "city": "Izumo",
      "country": "Japonia",
      "time": "Izumo - Japonia, 13:00",
      "location": "Chram Izumo Taisha, 195 Kitsukihigashi, Taishacho",
      "cleanTime": "13:00",
      "day": "schedule14"
    },
    "izumo20": {
      "city": "Izumo",
      "country": "Japonia",
      "time": "Izumo - Japonia",
      "location": "Chram Izumo Taisha, 195 Kitsukihigashi, Taishacho",
      "cleanTime": "",
      "day": "schedule20"
    },
    "kamloops": {
      "city": "Kamloops, BC",
      "country": "Kanada",
      "time": "Kamloops, BC - Kanada, 15:00 - 16:00",
      "location": "Ratusz",
      "cleanTime": "15:00 - 16:00",
      "day": "schedule13"
    },
    "kyiv": {
      "city": "Kijów",
      "country": "Ukraina",
      "time": "Kijów - Ukraina, 17:00-18:00",
      "location": "Majdan Niepodległości",
      "cleanTime": "17:00 - 18:00",
      "day": "schedule14"
    },
    "leipzig": {
      "city": "Lipsk",
      "country": "Niemcy",
      "time": "Lipsk - Niemcy, 12:00 - 13:00",
      "location": "Willy Brandt Platz",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "london": {
      "city": "Londyn",
      "country": "Wielka Brytania",
      "time": "Londyn - Wielka Brytania, 18:30 - pokaz filmu",
      "location": "Dom Ukraiński, 154 Holland Park Avenue",
      "cleanTime": "18:30 - pokaz filmu",
      "day": "schedule12"
    },
    "losAngeles": {
      "city": "Los Angeles",
      "country": "USA",
      "time": "Los Angeles - USA, 15:30",
      "location": "4051 Melrose Ave",
      "cleanTime": "15:30",
      "day": "schedule14"
    },
    "malaga": {
      "city": "Malaga",
      "country": "Hiszpania",
      "time": "Malaga - Hiszpania, 18:00 - pokaz filmu",
      "location": "Maydan - Centro Historico Cultural Ukraniano",
      "cleanTime": "18:00 - pokaz filmu",
      "day": "schedule13"
    },
    "manchester": {
      "city": "Manchester",
      "country": "Wielka Brytania",
      "time": "Manchester - Wielka Brytania, 14:00 - 15:30",
      "location": "St Peter's Square, pomnik Emmeline Pankhurst",
      "cleanTime": "14:00 - 15:30",
      "day": "schedule13"
    },
    "mexicoCity": {
      "city": "Miasto Meksyk",
      "country": "Meksyk",
      "time": "Miasto Meksyk - Meksyk, 11:00",
      "location": "Alameda Central, fontanna „Ameryki” (między pomnikiem Hemiciclo a Juárez a kioskiem)",
      "cleanTime": "11:00",
      "day": "schedule14"
    },
    "milan": {
      "city": "Mediolan",
      "country": "Włochy",
      "time": "Mediolan - Włochy, 15:00",
      "location": "Katedra w Mediolanie (Duomo)",
      "cleanTime": "15:00",
      "day": "schedule14"
    },
    "munich": {
      "city": "Monachium",
      "country": "Niemcy",
      "time": "Monachium - Niemcy, 17:00 - 19:00",
      "location": "Odeonsplatz",
      "cleanTime": "17:00 - 19:00",
      "day": "schedule14"
    },
    "newYork13": {
      "city": "Nowy Jork",
      "country": "USA",
      "time": "Nowy Jork - USA, 16:00",
      "location": "Times Square",
      "cleanTime": "16:00",
      "day": "schedule13"
    },
    "newYork14": {
      "city": "Nowy Jork",
      "country": "USA",
      "time": "Nowy Jork - USA, 13:00 - 14:00",
      "location": "Times Square",
      "cleanTime": "13:00 - 14:00",
      "day": "schedule14"
    },
    "nienburg": {
      "city": "Nienburg (Weser)",
      "country": "Niemcy",
      "time": "Nienburg (Weser) - Niemcy, 17:00",
      "location": "Stettiner Str.2A",
      "cleanTime": "17:00",
      "day": "schedule13"
    },
    "oslo": {
      "city": "Oslo",
      "country": "Norwegia",
      "time": "Oslo - Norwegia, 12:00 - 13:00",
      "location": "Eidsvoll Plass, Stortinget",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule14"
    },
    "ostersund": {
      "city": "Östersund",
      "country": "Szwecja",
      "time": "Östersund - Szwecja, 11:00 - 14:00",
      "location": "Stortorget (rynek główny)",
      "cleanTime": "11:00 - 14:00",
      "day": "schedule13"
    },
    "ottawa12": {
      "city": "Ottawa",
      "country": "Kanada",
      "time": "Ottawa - Kanada, 12:30 - 13:30",
      "location": "Ambasada Rosji",
      "cleanTime": "12:30 - 13:30",
      "day": "schedule12"
    },
    "ottawa13": {
      "city": "Ottawa",
      "country": "Kanada",
      "time": "Ottawa - Kanada, 12:00",
      "location": "Ambasada USA",
      "cleanTime": "12:00",
      "day": "schedule13"
    },
    "paris": {
      "city": "Paryż",
      "country": "Francja",
      "time": "Paryż - Francja, 15:30",
      "location": "Skwer Tarasa Szewczenki -> fontanna Saint-Michel (marsz)",
      "cleanTime": "15:30",
      "day": "schedule13"
    },
    "plovdiv": {
      "city": "Płowdiw",
      "country": "Bułgaria",
      "time": "Płowdiw - Bułgaria, 16:00 - 17:00",
      "location": "przy Domu Lewskiego",
      "cleanTime": "16:00 - 17:00",
      "day": "schedule14"
    },
    "prague": {
      "city": "Praga",
      "country": "Czechy",
      "time": "Praga - Czechy, 14:00",
      "location": "plac Palackiego",
      "cleanTime": "14:00",
      "day": "schedule13"
    },
    "rosendal": {
      "city": "Rosendal",
      "country": "Republika Południowej Afryki",
      "time": "Rosendal - Republika Południowej Afryki, 11:00",
      "location": "Siedziba Południowoafrykańskiej Służby Policyjnej",
      "cleanTime": "11:00",
      "day": "schedule13"
    },
    "sanAndres": {
      "city": "San Andrés, Teneryfa",
      "country": "Hiszpania",
      "time": "San Andrés, Teneryfa - Hiszpania, 13:00",
      "location": "--",
      "cleanTime": "13:00",
      "day": "schedule13"
    },
    "sanDiego": {
      "city": "San Diego",
      "country": "USA",
      "time": "San Diego - USA, 14:00 - 16:00",
      "location": "Pomnik El Cida, Balboa Park",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule14"
    },
    "sanFrancisco": {
      "city": "San Francisco",
      "country": "USA",
      "time": "San Francisco - USA, 14:00",
      "location": "Ferry Plaza, Embarcadero",
      "cleanTime": "14:00",
      "day": "schedule14"
    },
    "schwerin": {
      "city": "Schwerin",
      "country": "Niemcy",
      "time": "Schwerin - Niemcy, 19:00 - pokaz filmu",
      "location": "Internationales Haus, Ziegenmarkt 4",
      "cleanTime": "19:00 - pokaz filmu",
      "day": "schedule13"
    },
    "seattle": {
      "city": "Seattle",
      "country": "USA",
      "time": "Seattle - USA, 12:30 - 15:30",
      "location": "1005 E Union St.",
      "cleanTime": "12:30 - 15:30",
      "day": "schedule13"
    },
    "svetiVlas": {
      "city": "Sweti Wlas",
      "country": "Bułgaria",
      "time": "Sweti Wlas - Bułgaria, do potwierdzenia",
      "location": "",
      "cleanTime": "do potwierdzenia",
      "day": "scheduleTBC"
    },
    "sydney": {
      "city": "Sydney",
      "country": "Australia",
      "time": "Sydney - Australia, 14:00",
      "location": "Ratusz w Sydney",
      "cleanTime": "14:00",
      "day": "schedule13"
    },
    "tallinn": {
      "city": "Tallinn",
      "country": "Estonia",
      "time": "Tallinn - Estonia, 15:00 - pokaz filmu i wiec",
      "location": "Kino Sõprus, Vana-Posti tn.8",
      "cleanTime": "15:00 - pokaz filmu i wiec",
      "day": "schedule13"
    },
    "tarragona": {
      "city": "Tarragona",
      "country": "Hiszpania",
      "time": "Tarragona - Hiszpania, 18:30",
      "location": "Balcó Mediterrani",
      "cleanTime": "18:30",
      "day": "schedule14"
    },
    "theHague": {
      "city": "Haga",
      "country": "Holandia",
      "time": "Haga - Holandia, 13:00 - 15:00",
      "location": "Przed Pałacem Pokoju / MTK",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule14"
    },
    "tbilisi": {
      "city": "Tbilisi",
      "country": "Gruzja",
      "time": "Tbilisi - Gruzja, 21:00",
      "location": "Tbilisi",
      "cleanTime": "21:00",
      "day": "schedule14"
    },
    "tranas": {
      "city": "Tranås",
      "country": "Szwecja",
      "time": "Tranås - Szwecja, 11:00 - 13:00, 13:00",
      "location": "Storgatan 49 (Kultivera)",
      "cleanTime": "11:00 - 13:00, 13:00",
      "day": "schedule13"
    },
    "vienna": {
      "city": "Wiedeń",
      "country": "Austria",
      "time": "Wiedeń - Austria, 16:00 - 18:00",
      "location": "Stock-im-Eisen-Platz (obok katedry św. Szczepana)",
      "cleanTime": "16:00 - 18:00",
      "day": "schedule14"
    },
    "washingtonDC": {
      "city": "Waszyngton",
      "country": "USA",
      "time": "Waszyngton - USA, 12:30 - 13:30",
      "location": "Biały Dom",
      "cleanTime": "12:30 - 13:30",
      "day": "schedule14"
    },
    "wroclaw": {
      "city": "Wrocław",
      "country": "Polska",
      "time": "Wrocław - Polska, 13:00",
      "location": "Plac Wolności (od strony Narodowego Forum Muzyki)",
      "cleanTime": "13:00",
      "day": "schedule14"
    }
  },
  "help": {
    "organise": "Kontakt:",
    "email": "khersonhumansafari@gmail.com",
    "actionEmail": "antihumansafari@gmail.com",
    "share": "Udostępnij na {{platform}}",
    "website": "Strona internetowa",
    "facebook": "Facebook",
    "x": "X",
    "youtube": "YouTube",
    "bluesky": "Bluesky",
    "donate": "Wesprzyj",
    "donateIntro": "To inicjatywy, które zapewniają skuteczną, ukierunkowaną pomoc, by bezpośrednio chronić cywilów w Chersoniu przed Human Safari.",
    "shareTitle": "Przekaż dalej",
    "filmScreening": "Zorganizuj pokaz filmu dokumentalnego Kherson Human Safari:",
    "howItStarted": "Jak to się zaczęło",
    "khs": {
      "name": "Kherson Human Safari",
      "desc": "Zarina Zabrisky, dziennikarka i filmowczyni, poprowadziła ogólnoświatowy wiec i wyreżyserowała film dokumentalny Kherson Human Safari."
    },
    "fellas": {
      "name": "Fellas4Europe",
      "desc": "Ochrona cywilów na ulicach Chersonia — ochrona ludności przed atakami dronów.",
      "foodDesc": "Pomoc żywnościowa.",
      "foodNote": "Przy wpłacie wpisz „Food for Cherson” w tytule przelewu."
    },
    "ahs": {
      "name": "Anti Human Safari Project",
      "desc": "Wykrywacze dronów i kamizelki ochronne dla wolontariuszy i służb ratunkowych w Chersoniu."
    },
    "pageTitle": "Stop Human Safari",
    "sectionIntro": "Od lata 2024 roku rosyjskie wojsko używa małych dronów, by polować na cywilów, zabijać ich i terroryzować na ulicach Chersonia i innych przyfrontowych miast Ukrainy.",
    "sectionIntro2": "To systematyczna i celowa kampania mordów — rosyjscy operatorzy dronów otwarcie publikują nagrania swoich ofiar na kanałach Telegram, by się nimi chwalić. W maju 2025 roku ONZ uznała Human Safari za trwającą zbrodnię wojenną.",
    "sectionIntro3": "Robi się zbyt mało. Human Safari musi się skończyć.",
    "sectionIntroBold": "TY możesz pomóc. Oto jak",
    "step2Title": "Zorganizuj",
    "step3Title": "Mów o tym",
    "step3Para": "Używaj hashtagów",
    "step3ParaPost": "i opowiadaj innym o Human Safari",
    "instagram": "Instagram",
    "step2Bullet1": "pokaz filmu",
    "step2Bullet2": "akcję publiczną",
    "step2Bullet3": "relację w mediach",
    "publicActionLead": "Zwróć uwagę na Human Safari tam, gdzie jesteś.",
    "reachOutPre": "Możesz",
    "reachOut": "się z nami skontaktować",
    "reachOutPost": "po pomysły i materiały",
    "newsCoverageLead": "przez swoje kontakty w mediach. Opowiedz im o Human Safari i o zagrożeniu dla wszystkich obecnych i przyszłych stref konfliktu.",
    "putInTouchPre": "Możesz też",
    "putInTouch": "skontaktować ich bezpośrednio z nami",
    "inform": "Informuj",
    "informSub": "siebie i innych",
    "policyTitle": "Polityka",
    "policyBody": "Proponowana ustawa LORA (Liability for Operators and Responsible Authorities Act) wprowadziłaby sankcje wobec całego łańcucha odpowiedzialności — od rosyjskich operatorów dronów FPV i dowódców po najwyższe dowództwo wojskowe, a także producentów i dostawców umożliwiających produkcję dronów i ich użycie przeciwko cywilom.",
    "policyHelp": "Możesz pomóc na poziomie politycznym?",
    "getInTouch": "Skontaktuj się",
    "disdict": {
      "title": "Słownik dezinformacji",
      "link": "Human Safari"
    },
    "kryla": {
      "name": "Fundacja Kryła",
      "desc": "Wesprzyj ich w opłaceniu zakwaterowania i podstawowych artykułów dla mieszkańców Oleszek."
    }
  },
  "action": {
    "intro": "Zaczęliśmy od ogólnoświatowej demonstracji. Teraz możesz:",
    "helpLink": "pomóc tutaj"
  },
  "accounts": {
    "heading": "Relacje"
  },
  "media": {
    "close": "Zamknij",
    "view": "Zobacz materiały",
    "previous": "Poprzednie",
    "next": "Następne",
    "andrushenkoCredit": "Ołeksandr Andruszenko, fotoreporter serwisu Vgoru",
    "khersonPoliceCredit": "z @khersonpolice",
    "antypenkoCredit": "Iwan Antypenko, fotoreporter z Chersonia",
    "telegramChannelCredit": "opublikowane przez rosyjski kanał Telegram Human Safari „od Mariupola po Karpaty”",
    "fruitSellerDescription": "Sprzedawca owoców ścigany przez drona światłowodowego",
    "burntCarDescription": "Spalony samochód w Chersoniu",
    "bridgeAttackDescription": "Nastolatek zamordowany przez drona FPV pod mostem w Chersoniu",
    "busAttackDescription": "Jeden z wielu ataków dronów FPV na komunikację miejską",
    "fpvDroneDescription": "Dron FPV na polowaniu Human Safari",
    "antiDroneNetsDescription": "Ulica w Chersoniu osłonięta siatkami przed dronami Human Safari",
    "firefighterDescription": "Strażak gasi samochód po ataku Human Safari, za nim leży ofiara"
  },
  "follow": {
    "title": "Obserwuj",
    "subHumanSafari": "rzetelne źródła relacjonujące z Chersonia i o Human Safari",
    "subDroneSiege": "rzetelne źródła relacjonujące z Chersonia i o oblężeniu dronami",
    "localPress": "lokalna prasa ukraińskojęzyczna",
    "lang": {
      "english": "angielski",
      "german": "niemiecki",
      "ukrainian": "ukraiński"
    },
    "language": "Język: {{list}}",
    "languages": "Języki: {{list}}",
    "langSeparator": ", ",
    "zabrisky": {
      "name": "Zarina Zabrisky",
      "desc": "Amerykańska dziennikarka i filmowczyni mieszkająca w Chersoniu, pisze dla Byline Times i Euromaidan Press; reżyserka filmu dokumentalnego Kherson Human Safari."
    },
    "naber": {
      "name": "Ibrahim Naber",
      "desc": "Główny reporter niemieckiego dziennika Die Welt; regularnie relacjonuje Human Safari w Chersoniu."
    },
    "kelley": {
      "name": "Brendan Kelley",
      "desc": "Autor Kherson Weekly, bieżącego rejestru rosyjskich ataków dronów na cywilów w Chersoniu i okolicznych wsiach."
    },
    "vgoru": {
      "name": "Vgoru",
      "desc": "Niezależne medium z obwodu chersońskiego, relacjonujące życie pod ostrzałem i pod okupacją."
    },
    "suspilne": {
      "name": "Suspilne Chersoń",
      "desc": "Chersońska redakcja ukraińskiego nadawcy publicznego."
    },
    "most": {
      "name": "MOST",
      "desc": "Lokalna agencja informacyjna z Chersonia, relacjonująca wydarzenia w mieście i regionie."
    }
  },
  "rallies": {
    "oleshky2026": {
      "heroStop": "STOP OBLĘŻENIU DRONAMI",
      "heroSave": "RATUJMY OLESZKI",
      "worldwideRally": "Ogólno&shy;światowa demonstracja",
      "heroDate": "Październik",
      "infoText1": "Tysiące cywilów są uwięzione w oblężeniu dronami w Oleszkach, Hołej Prystani, Starej Zburiwce i Nowej Zburiwce. Rosyjskie siły wykorzystują ich jako żywe tarcze, kryjąc się za nimi podczas ataków dronów Human Safari na przeciwległy brzeg.",
      "infoText2": "Kryzys jest dramatyczny — brakuje żywności, wody, opieki medycznej, leków, prądu, gazu i łączności. Drogi są gęsto zaminowane, a drony ograniczają możliwość poruszania się. <bold>TY możesz pomóc. Dołącz do tysięcy ludzi na całym świecie, którzy domagają się zakończenia oblężenia dronami.</bold>",
      "imageAlt": "Wygłodzony pies wśród ludzkich kości w zrujnowanych Oleszkach, pod czerwonym niebem pełnym dronów, z napisem Stop Russian Drone Siege",
      "demandsTitle": "Wzywamy do:",
      "demand1": "bezpiecznych i skutecznych korytarzy humanitarnych do Oleszek i innych dotkniętych miejscowości.",
      "demand2": "natychmiastowej pomocy humanitarnej i wsparcia dla ofiar ataków human safari.",
      "demand3": "odpowiednich sankcji wobec osób i łańcuchów dostaw odpowiedzialnych za ataki na ludność cywilną.",
      "demand4": "działań zniechęcających do używania małych dronów do systematycznego atakowania i terroryzowania cywilów w Chersoniu, na Ukrainie i gdzie indziej.",
      "cities": {
        "edinburgh": {
          "city": "Edynburg",
          "country": "Wielka Brytania",
          "time": "Edynburg - Wielka Brytania, 14:00",
          "location": "Pomnik księcia Wellingtona",
          "cleanTime": "14:00",
          "day": "schedule26"
        },
        "birmingham": {
          "city": "Birmingham",
          "country": "Wielka Brytania",
          "time": "Birmingham - Wielka Brytania, 14:00 - 16:00",
          "location": "Naprzeciwko Hall of Memory, B1 2ND",
          "cleanTime": "14:00 - 16:00",
          "day": "schedule3"
        },
        "vienna": {
          "city": "Wiedeń",
          "country": "Austria",
          "time": "Wiedeń - Austria, 15:00 - 17:00",
          "location": "Stephansplatz, 1010 Wiedeń",
          "cleanTime": "15:00 - 17:00",
          "day": "schedule27"
        },
        "munich": {
          "city": "Monachium",
          "country": "Niemcy",
          "time": "Monachium - Niemcy, 15:00 - 17:00",
          "location": "Marienplatz, 80331 Monachium",
          "cleanTime": "15:00 - 17:00",
          "day": "schedule3"
        },
        "london": {
          "city": "Londyn",
          "country": "Wielka Brytania",
          "time": "Londyn - Wielka Brytania, 16:00 - 18:00",
          "location": "Downing Street",
          "cleanTime": "16:00 - 18:00",
          "day": "schedule27"
        },
        "manchester": {
          "city": "Manchester",
          "country": "Wielka Brytania",
          "time": "Manchester - Wielka Brytania, 14:00 - 15:30",
          "location": "St Peter's Square",
          "cleanTime": "14:00 - 15:30",
          "day": "schedule26"
        },
        "sydney": {
          "city": "Sydney",
          "country": "Australia",
          "time": "Sydney - Australia, 14:00",
          "location": "Ratusz w Sydney",
          "cleanTime": "14:00",
          "day": "schedule26"
        },
        "paris": {
          "city": "Paryż",
          "country": "Francja",
          "time": "Paryż - Francja, 15:30 - 18:30",
          "location": "Od cerkwi św. Włodzimierza do Place Saint-Michel",
          "cleanTime": "15:30 - 18:30",
          "day": "schedule26"
        },
        "parisSep30": {
          "city": "Paryż",
          "country": "Francja",
          "time": "Paryż - Francja, 18:00",
          "location": "Stacja metra Rambuteau",
          "cleanTime": "18:00",
          "day": "schedule30"
        },
        "lyon": {
          "city": "Lyon",
          "country": "Francja",
          "time": "Lyon - Francja, 14:00",
          "location": "Place de la Comédie",
          "cleanTime": "14:00",
          "day": "schedule27"
        },
        "dublin": {
          "city": "Dublin",
          "country": "Irlandia",
          "time": "Dublin - Irlandia, 13:00",
          "location": "Poczta Główna (GPO)",
          "cleanTime": "13:00",
          "day": "schedule4"
        },
        "brussels": {
          "city": "Bruksela",
          "country": "Belgia",
          "time": "Bruksela - Belgia, 10:00 - 11:00",
          "location": "La Petite rue de la Loi, 1040 Bruksela (rondo Schumana)",
          "cleanTime": "10:00 - 11:00",
          "day": "schedule28"
        },
        "ottawa": {
          "city": "Ottawa",
          "country": "Kanada",
          "time": "Ottawa - Kanada, 12:30 - 13:30",
          "location": "Ambasada Rosji, 285 Charlotte St",
          "cleanTime": "12:30 - 13:30",
          "day": "schedule2"
        },
        "nantes": {
          "city": "Nantes",
          "country": "Francja",
          "time": "Nantes - Francja, 15:00 - 16:30",
          "location": "Place Royale",
          "cleanTime": "15:00 - 16:30",
          "day": "schedule3"
        },
        "gdansk": {
          "city": "Gdańsk",
          "country": "Polska",
          "time": "Gdańsk - Polska, 18:30 - 19:30",
          "location": "Długi Targ, przy Fontannie Neptuna",
          "cleanTime": "18:30 - 19:30",
          "day": "schedule27"
        },
        "chicago": {
          "city": "Chicago",
          "country": "USA",
          "time": "Chicago - USA, 13:00",
          "location": "410 N. Michigan ave. (budynek Wrigley)",
          "cleanTime": "13:00",
          "day": "schedule27"
        },
        "chicagoOct4": {
          "city": "Chicago",
          "country": "USA",
          "time": "Chicago - USA, 13:00",
          "location": "410 N. Michigan ave. (budynek Wrigley)",
          "cleanTime": "13:00",
          "day": "schedule4"
        },
        "chicagoOct11": {
          "city": "Chicago",
          "country": "USA",
          "time": "Chicago - USA, 13:00",
          "location": "410 N. Michigan ave. (budynek Wrigley)",
          "cleanTime": "13:00",
          "day": "schedule11"
        },
        "chicagoOct18": {
          "city": "Chicago",
          "country": "USA",
          "time": "Chicago - USA, 13:00",
          "location": "410 N. Michigan ave. (budynek Wrigley)",
          "cleanTime": "13:00",
          "day": "schedule18"
        },
        "dresden": {
          "city": "Drezno",
          "country": "Niemcy",
          "time": "Drezno - Niemcy, 14:00",
          "location": "Neumarkt",
          "cleanTime": "14:00",
          "day": "schedule4"
        },
        "malaga": {
          "city": "Malaga",
          "country": "Hiszpania",
          "time": "Malaga - Hiszpania, 19:00",
          "location": "Plaza de la Marina",
          "cleanTime": "19:00",
          "day": "schedule3"
        },
        "londonSep29": {
          "city": "Londyn",
          "country": "Wielka Brytania",
          "time": "Londyn - Wielka Brytania, 18:00",
          "location": "Trafalgar Square",
          "cleanTime": "18:00",
          "day": "schedule29"
        },
        "plovdiv": {
          "city": "Płowdiw",
          "country": "Bułgaria",
          "time": "Płowdiw - Bułgaria, 17:00",
          "location": "Główna ulica (Glawnata), przy schodach „Kamenica” / napisie „Together”",
          "cleanTime": "17:00",
          "day": "schedule3"
        },
        "budapest": {
          "city": "Budapeszt",
          "country": "Węgry",
          "time": "Budapeszt - Węgry, 17:00 - 20:00",
          "location": "Szent István tér (plac św. Stefana)",
          "cleanTime": "17:00 - 20:00",
          "day": "schedule30"
        },
        "londonOct1": {
          "city": "Londyn",
          "country": "Wielka Brytania",
          "time": "Londyn - Wielka Brytania, 17:00",
          "location": "Trafalgar Square",
          "cleanTime": "17:00",
          "day": "schedule1"
        },
        "londonOct3": {
          "city": "Londyn",
          "country": "Wielka Brytania",
          "time": "Londyn - Wielka Brytania, 12:00",
          "location": "Trafalgar Square",
          "cleanTime": "12:00",
          "day": "schedule3"
        },
        "hamburg": {
          "city": "Hamburg",
          "country": "Niemcy",
          "time": "Hamburg - Niemcy, 14:00 - 16:00",
          "location": "Landungsbrücken, Jan-Fedder-Promenade, na wysokości pomostu 1, 20359 Hamburg",
          "cleanTime": "14:00 - 16:00",
          "day": "schedule3"
        },
        "kiel": {
          "city": "Kilonia",
          "country": "Niemcy",
          "time": "Kilonia - Niemcy, 15:00 - 16:00",
          "location": "Holstenstraße",
          "cleanTime": "15:00 - 16:00",
          "day": "schedule4"
        },
        "oslo": {
          "city": "Oslo",
          "country": "Norwegia",
          "time": "Oslo - Norwegia",
          "location": "Eidsvolls plass",
          "cleanTime": "",
          "day": "schedule3"
        },
        "leipzig": {
          "city": "Lipsk",
          "country": "Niemcy",
          "time": "Lipsk - Niemcy, 17:00 - 18:00",
          "location": "Dworzec główny (Willy-Brandt-Platz)",
          "cleanTime": "17:00 - 18:00",
          "day": "schedule5"
        },
        "londonOct9": {
          "city": "Londyn",
          "country": "Wielka Brytania",
          "time": "Londyn - Wielka Brytania, 17:00",
          "location": "Trafalgar Square",
          "cleanTime": "17:00",
          "day": "schedule9"
        },
        "londonOct10": {
          "city": "Londyn",
          "country": "Wielka Brytania",
          "time": "Londyn - Wielka Brytania, 13:00",
          "location": "Trafalgar Square",
          "cleanTime": "13:00",
          "day": "schedule10"
        },
        "dublinOct11": {
          "city": "Dublin",
          "country": "Irlandia",
          "time": "Dublin - Irlandia, 13:00",
          "location": "Poczta Główna (GPO)",
          "cleanTime": "13:00",
          "day": "schedule11"
        },
        "dublinOct25": {
          "city": "Dublin",
          "country": "Irlandia",
          "time": "Dublin - Irlandia, 14:00",
          "location": "Poczta Główna (GPO)",
          "cleanTime": "14:00",
          "day": "schedule25"
        },
        "nantesOct31": {
          "city": "Nantes",
          "country": "Francja",
          "time": "Nantes - Francja, 15:00 - 16:30",
          "location": "Place Royale",
          "cleanTime": "15:00 - 16:30",
          "day": "schedule31"
        }
      },
      "posterStopSiege": "Stop rosyjskiemu oblężeniu dronami",
      "posterNoRoadOut": "Drogi do Oleszek i z Oleszek są zablokowane",
      "posterHumanitarianCatastrophe": "Oleszki. Katastrofa humanitarna pod okupacją",
      "seeGallery": "Zobacz / pobierz plakaty"
    },
    "artBy": "Autor: {{name}}",
    "downloadPoster": "Pobierz plakat",
    "reel": {
      "download": "Pobierz wideo (MP4)"
    },
    "addDemo": {
      "title": "dodaj swoją demonstrację",
      "where": "gdzie: miejscowość/miasto",
      "contact": "e-mail/telefon",
      "message": "wiadomość: kogo reprezentujesz, czy demonstracja jest potwierdzona czy w przygotowaniu, link do ogłoszenia w sieci, inne szczegóły",
      "submit": "Wyślij",
      "sending": "Wysyłanie…",
      "thanks": "Dziękujemy! Odezwiemy się.",
      "error": "Coś poszło nie tak. Spróbuj ponownie.",
      "contactInvalid": "Podaj poprawny adres e-mail lub numer telefonu z kierunkowym kraju (np. +48 600 123 456).",
      "date": "data",
      "time": "godzina rozpoczęcia (lokalna)",
      "whereInvalid": "Podaj nazwę miejscowości lub miasta, np. Paryż albo Kijów, Ukraina.",
      "datePlaceholder": "data: dd/mm"
    }
  },
  "seo": {
    "oleshky": {
      "title": "Stop oblężeniu dronami — Ratujmy Oleszki | Demonstracje",
      "description": "Rosyjskie drony oblegają tysiące cywilów w okupowanych Oleszkach na Ukrainie, odciętych od żywności, wody i leków. Znajdź demonstrację w pobliżu i domagaj się bezpiecznego przejścia."
    },
    "leftBank": {
      "title": "Oblężenie dronami Oleszek i okupowanego obwodu chersońskiego",
      "description": "Tysiące cywilów są uwięzione w rosyjskim oblężeniu dronami w okupowanych Oleszkach, Hołej Prystani i pobliskich wsiach. Dowiedz się, co się dzieje i jak możesz pomóc."
    },
    "help": {
      "title": "Stop Human Safari — Rosyjskie drony polują na cywilów w Chersoniu",
      "description": "Rosyjskie drony polują na cywilów w Chersoniu na Ukrainie. Dowiedz się o zbrodni wojennej Human Safari i o tym, jak pomóc ją powstrzymać."
    },
    "action": {
      "title": "Ogólnoświatowy wiec, grudzień 2025 — Stop Human Safari",
      "description": "Zdjęcia, plakaty i miejsca ogólnoświatowego wiecu z grudnia 2025 przeciwko rosyjskim atakom dronów na cywilów w Chersoniu na Ukrainie."
    },
    "rallies": {
      "title": "Zdjęcia z wieców — Stop Human Safari",
      "description": "Zdjęcia z wieców na całym świecie przeciwko rosyjskim atakom dronów na cywilów w Chersoniu na Ukrainie."
    },
    "resources": {
      "title": "Human Safari — Raporty, artykuły i relacje świadków",
      "description": "Raporty, artykuły, wywiady i relacje naocznych świadków o rosyjskich atakach dronów na cywilów w Chersoniu na Ukrainie."
    },
    "reel": {
      "title": "Ratujmy Oleszki — Wideo z demonstracji",
      "description": "Wideo z ogólnoświatowych demonstracji „Ratujmy Oleszki”, październik 2026."
    }
  }
}
